import { fromKebabToTitleCase } from "shared/core/utils/string";
import { CheckboxGridItem } from "src/UIPalette/components/CheckboxGrid/CheckboxGrid";

export const getFilterDefaultValues = (
  enums: Record<string, string>,
  { getSelected, getDisabled }: { getSelected?: (value: string) => boolean; getDisabled?: (value: string) => boolean }
): CheckboxGridItem[] =>
  Object.values(enums).map((value, index) => {
    const selected = !!(getSelected && getSelected(value));
    const disabled = !!(getDisabled && getDisabled(value));

    return {
      id: index.toString(),
      key: value,
      displayText: fromKebabToTitleCase(value),
      selected,
      disabled,
    };
  });
